/**
 * Fantasy Console 0 - Cart Card Skeleton
 *
 * Skeleton loading placeholder that matches CartCard layout.
 */

import { Skeleton, SkeletonText } from '../UI/Skeleton'
import styles from './CartCardSkeleton.module.css'

export function CartCardSkeleton() {
  return (
    <div className={styles.card}>
      {/* Thumbnail placeholder */}
      <Skeleton className={styles.thumbnail} />

      {/* Info section */}
      <div className={styles.info}>
        {/* Title */}
        <SkeletonText width='70%' height='14px' />

        {/* Author */}
        <SkeletonText width='40%' height='12px' />

        {/* Description lines */}
        <SkeletonText width='100%' height='12px' />
        <SkeletonText width='60%' height='12px' />

        {/* Stats row */}
        <div className={styles.statsRow}>
          <SkeletonText width='30px' height='12px' />
          <SkeletonText width='50px' height='11px' />
        </div>

        {/* Date */}
        <SkeletonText width='120px' height='11px' />
      </div>

      {/* Actions */}
      <div className={styles.actions}>
        <Skeleton className={styles.actionButton} />
        <Skeleton className={styles.actionButton} />
        <Skeleton className={styles.loadButton} />
      </div>
    </div>
  )
}
